import style from "./style.module.css"
const SplashScreen = () => {
    return (
        <div className={style.mainDiv}>
            <p className={style.splashLogo}>Secure Examination</p>
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}

export default SplashScreen;